/** ADDRESS */

export enum AddressCodeEnum {
  ADDRESS_POSTAL = 1,
  ADDRESS_BILLING = 2,
}

export enum AddressTypeEnum {
  ADDRESS_POSTAL = 'Adresse postale',
  ADDRESS_BILLING = 'Adresse de facturation',
}

/** PRODUCT */

export enum ProductCodeHubbixEnum {
  GESTION_COMMERCIALE = 1,
  GESTION_COMMERCIALE_SILVER = 32768,
  COMPTABILITE = 2,
  COMPTABILITE_SILVER = 65536,
  FORMATION_COMPTABILITE = 101,
  FORMATION_GESTION_COMMERCIALE = 102,
  FORMATION_COMPTA_GESTION_COMMERCIAL = 103,
  PAIE = 512,
  BATIMENT = 2048,
  BATIMENT_SILVER = 131072,
  OPTION_UTILISATEUR = 99,
  OPTION_BANQUE = 98,
  OPTION_UTILISATEUR_SILVER = 96,
  OPTION_BANQUE_SILVER = 95,
}

export enum ProductCodeSapEnum {
  GESTION_COMMERCIALE = '1029J001FAC',
  GESTION_COMMERCIALE_SILVER = '1029J004FAD',
  COMPTABILITE = '1036J001FAB',
  COMPTABILITE_SILVER = '1036J004FAD',
  PAIE = '1025J001FAE',
  BATIMENT = '1039J001FAA',
  BATIMENT_SILVER = '1039J004FAA',
  FORMATION_COMPTABILITE = '4036A003FAB',
  FORMATION_GESTION_COMMERCIALE = '4029A003FAB',
  FORMATION_COMPTA_GESTION_COMMERCIAL = '4036A003FAD',
  OPTION_UTILISATEUR = '6000J00EFAE',
  OPTION_BANQUE = '6000J00FFAB',
  OPTION_UTILISATEUR_SILVER = '6000J00EFAF',
  OPTION_BANQUE_SILVER = '6000J00FFAC',
}

export enum ProductNameEnum {
  GESTION_COMMERCIALE = 'Hubbix Gestion commerciale',
  GESTION_COMMERCIALE_SILVER = 'Hubbix Gestion commerciale',
  COMPTABILITE = 'Hubbix Comptabilité',
  COMPTABILITE_SILVER = 'Hubbix Comptabilité',
  PAIE = 'Hubbix Paie',
  BATIMENT = 'Hubbix Bâtiment',
  BATIMENT_SILVER = 'Hubbix Bâtiment',
  FORMATION_COMPTABILITE = 'Formation Comptabilité 2 heures',
  FORMATION_GESTION_COMMERCIALE = 'Formation Gestion commerciale 2 heures',
  FORMATION_COMPTA_GESTION_COMMERCIALE = 'Formation Comptabilité Gestion commerciale 3 heures',
  OPTION_UTILISATEUR = 'Option Utilisateur',
  OPTION_BANQUE = 'Option Banque',
  OPTION_UTILISATEUR_SILVER = 'Option Utilisateur',
  OPTION_BANQUE_SILVER = 'Option Banque',
}

/** SOFTWARE */
export enum RolesTypeEnum {
  ADMINISTRATOR = 'Administrator',
  USER = 'User',
  CHART_ACCOUNTANT = 'ChartAccountant',
}

export enum DomainUpdateStatus {
  Cancelled = 0,
  Pending = 1,
  Unprocessed = 2,
  Validated = 3,
}

export enum PeriodicityEnum {
  Mensuel = 1,
  Annuel = 2,
}

export enum PaymentModEnum {
  SEPA = 1,
  CB = 2,
}
